import VAutocomplete from './VAutocomplete';
export { VAutocomplete };
export default VAutocomplete;
//# sourceMappingURL=index.js.map